/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Hub_Mode_StandaloneInputs */

const cs_social_hub_mode_standalone = /** @type {(inputs: Social_Hub_Mode_StandaloneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samostatný příspěvek`)
};

const en_social_hub_mode_standalone = /** @type {(inputs: Social_Hub_Mode_StandaloneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standalone post`)
};

/**
* | output |
* | --- |
* | "Standalone post" |
*
* @param {Social_Hub_Mode_StandaloneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_hub_mode_standalone = /** @type {((inputs?: Social_Hub_Mode_StandaloneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Hub_Mode_StandaloneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_hub_mode_standalone(inputs)
	return cs_social_hub_mode_standalone(inputs)
});